import * as React from 'react';
import logo from "../../assets/images/ZZ5H.gif"
import "../../Stylesheets/loader.scss"
export default function CircularIndeterminatecard() {
  return (
    <div className='loader_main_card'>
<img src={logo} alt="loading..." className='loaderimg_card'  />
</div>
    );
}